import { getSuggestionTitle } from "@/components/suggestions/list/utils";
import { flattenSuggestions, groupSuggestions } from "@/components/suggestions/utils";

import type { SuggestionsTranslateFn } from "@/components/suggestions/list/utils";
import type { Suggestion, SuggestionsGroup } from "@/components/suggestions/types";
import type { LocaleKeywords } from "@corca/data";

function titleText(suggestion: Suggestion, t: SuggestionsTranslateFn): string {
  const title = getSuggestionTitle(suggestion, t);

  return typeof title === "string" ? title : "";
}

function keywords(suggestion: Suggestion): string[] {
  const sources: (LocaleKeywords | undefined)[] = [
    suggestion.keywords,
    suggestion.type === "single" ? suggestion.item.keywords : undefined,
    suggestion.type === "single" ? suggestion.item.variantKeywords : undefined,
  ];

  return sources.flatMap((source) => Object.values(source ?? {}).flatMap(Object.keys));
}

function matches(suggestion: Suggestion, query: string, t: SuggestionsTranslateFn): boolean {
  if (titleText(suggestion, t).toLowerCase().includes(query)) {
    return true;
  }

  return keywords(suggestion).some((keyword) => keyword.toLowerCase().includes(query));
}

export function filterMenuGroups(
  groups: SuggestionsGroup[],
  query: string,
  t: SuggestionsTranslateFn,
): SuggestionsGroup[] {
  const trimmed = query.trim().toLowerCase();

  if (!trimmed) {
    return groups;
  }

  const flattened = flattenSuggestions(groups.flatMap((group) => group.items));

  return groupSuggestions(
    query,
    flattened.filter((suggestion) => !suggestion.disabled && matches(suggestion, trimmed, t)),
  );
}
